module.exports = __webpack_public_path__ + "img/guideline6.54ed50e3.png";